import React from 'react';

const HomeBgVideo = ({ HomeBgvideo }) => {
    if (!HomeBgvideo || !HomeBgvideo.video) return null; // no video case

    return (
        <div>
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                }}
            >
                <source src={HomeBgvideo.video} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};


export default HomeBgVideo;
